import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { AlertNotice, ModalInfo } from 'shared/components';
import { find, isArray, isEmpty, isUndefined } from 'lodash';
import BuildingIcon from 'assets/svgs/buildingIconBlack.svg';
import { SHIPPING_LABELS } from '../../constants';
import { LOCATION_EVENT_STATUS } from 'shared/constants';

import './Review.scss';

const mapCapacityTypes = (capacityTypes) => {
  const result = [];
  capacityTypes.map((capacity) => (result[capacity.id] = capacity.name));
  return result;
};

class Review extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { locations, modalOpen, onClose, onSave } = this.props;

    if (!modalOpen) {
      return null;
    }
    const capacityName = mapCapacityTypes(this.props.capacityTypes);
    const updates = this.props.getUpdates();

    return (
      <ModalInfo
        containerClass="modal-update-data-review-container"
        className="modal-update-data-review"
        modalIsOpen={modalOpen}
        closeModal={() => onClose(false)}
        onCancel={onClose}
        onSubmit={() => (isEmpty(updates) ? onClose(false) : onSave())}
        headerTitle={this.props.t('requestUpdate.title')}
        saveLabel={this.props.t(
          isEmpty(updates) ? 'common.labels.close' : 'requestUpdate.review.submitBtn'
        )}
        cancelLabel={this.props.t('requestUpdate.review.goBackBtn')}
        showCancel>
        <div className="review">
          <h5>{this.props.t('requestUpdate.review.title')}</h5>

          {!isEmpty(updates) ? (
            <>
              <AlertNotice message={this.props.t('requestUpdate.review.infoMessage')} />
              {!isEmpty(updates.locationEvents) && (
                <>
                  <div className="subtitle">{this.props.t('requestUpdate.capacityTab')}</div>
                  {updates.locationEvents.map((locationCapacities) => {
                    const location = find(locations, { id: locationCapacities.locationId });
                    return (
                      <div
                        className="location"
                        key={`location-capacities-${locationCapacities.locationId}`}>
                        <div className="location-title">
                          <BuildingIcon />
                          <span className="fw-bold">
                            {location.name}
                            {location.area && location.area.length > 0 && `, ${location.area}`}
                          </span>
                          {locationCapacities.status &&
                            locationCapacities.status.toUpperCase() !==
                              location.locationEvent.status && (
                              <>
                                <span> - </span>
                                <span className="is-updated fw-normal">
                                  {' '}
                                  {this.props.t(
                                    locationCapacities.status.toUpperCase() ===
                                      LOCATION_EVENT_STATUS.closed
                                      ? 'requestUpdate.review.locationClosed'
                                      : 'requestUpdate.review.locationOpened'
                                  )}
                                </span>
                              </>
                            )}
                        </div>
                        {locationCapacities.capacities &&
                          locationCapacities.capacities.map((capacityType) => (
                            <div
                              className="fw-bold"
                              key={`capacity-type-${capacityType.capacityTypeId}`}>
                              {capacityName[capacityType.capacityTypeId]} -{' '}
                              <span className="is-updated">
                                {this.props.t('requestUpdate.review.newCapacityLabel')}
                              </span>
                              :{' '}
                              <span className="is-updated fw-normal">{capacityType.capacity}</span>
                            </div>
                          ))}
                      </div>
                    );
                  })}
                </>
              )}

              {!isUndefined(updates.message) && (
                <>
                  <div className="subtitle">{this.props.t('requestUpdate.admissionTab')}</div>
                  {updates.message ? (
                    <div className="is-updated">
                      <div className="fw-bold">
                        {this.props.t('requestUpdate.review.newMessage')}
                      </div>
                      <div>{updates.message}</div>
                    </div>
                  ) : (
                    <div className="is-updated fw-bold">
                      {this.props.t('requestUpdate.review.deletedMessage')}
                    </div>
                  )}
                </>
              )}

              {!isEmpty(updates.shippingAddress) && (
                <>
                  <div className="subtitle">{this.props.t('requestUpdate.shippingTab')}</div>
                  {Object.entries(updates.shippingAddress).map((item) => {
                    const [key, value] = item;
                    return (
                      <div className="is-updated" key={key}>
                        <div className="fw-bold">{this.props.t(SHIPPING_LABELS[key])}</div>
                        <div>{isArray(value) ? value.map((item) => <div>{item}</div>) : value}</div>
                      </div>
                    );
                  })}
                </>
              )}
            </>
          ) : (
            <AlertNotice message={this.props.t('requestUpdate.review.noChangesMessage')} />
          )}
        </div>
      </ModalInfo>
    );
  }
}

export default withTranslation()(Review);
Review.propTypes = {
  t: PropTypes.func.isRequired,
};

Review.defaultProps = {};
